module.exports = __webpack_public_path__ + "img/don_russell.d616f408.png";